import React from 'react';

interface ReceiptUploadGuideProps {
    onUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ReceiptUploadGuide: React.FC<ReceiptUploadGuideProps> = ({ onUpload }) => {
    return (
        <>
            {/* Upload Guide */}
            <div className="upload-guide">
                <div className="guide-icon">📷</div>
                <h2 className="guide-title">영수증을 촬영해주세요</h2>
                <p className="guide-description">
                    영수증의 텍스트가 선명하게 보이도록<br />
                    촬영하면 자동으로 인식됩니다
                </p>
            </div>

            {/* Example Image */}
            <div className="example-section">
                <h3 className="example-title">촬영 가이드</h3>
                <div className="example-grid">
                    <div className="example-item">
                        <div className="example-box good">
                            <div className="example-receipt">
                                <div className="receipt-line"></div>
                                <div className="receipt-line short"></div>
                                <div className="receipt-line"></div>
                            </div>
                        </div>
                        <div className="example-label good">✓ 선명한 촬영</div>
                    </div>

                    <div className="example-item">
                        <div className="example-box bad">
                            <div className="example-receipt blurred">
                                <div className="receipt-line"></div>
                                <div className="receipt-line short"></div>
                                <div className="receipt-line"></div>
                            </div>
                        </div>
                        <div className="example-label bad">✕ 흐릿한 촬영</div>
                    </div>
                </div>
            </div>

            {/* Tips */}
            <div className="tips-section">
                <h3 className="tips-title">촬영 팁</h3>
                <ul className="tips-list">
                    <li className="tip-item">밝은 곳에서 촬영해주세요</li>
                    <li className="tip-item">영수증이 화면에 꽉 차게 촬영해주세요</li>
                    <li className="tip-item">글자가 선명하게 보이도록 초점을 맞춰주세요</li>
                </ul>
            </div>

            {/* Upload Button */}
            <div className="upload-button-section">
                <input
                    type="file"
                    id="receipt-upload"
                    className="file-input"
                    accept="image/*"
                    capture="environment"
                    onChange={onUpload}
                />
                <label htmlFor="receipt-upload" className="upload-button">
                    <span className="button-icon">📷</span>
                    <span className="button-text">영수증 촬영하기</span>
                </label>
            </div>
        </>
    );
};
